const selectors = {
    banner: '[data-countdown]',
    wrapper: '[data-countdown-wrapper]',
    content: '[data-countdown-content]',
    closeTrigger: '[data-countdown-close]',
};
const hasBeenClosed = (banner) => {
    const countdownClosed = sessionStorage.getItem('ra-countdown-closed');
    if (countdownClosed && countdownClosed === '1') {
        banner.classList.add('countdown--hide');
        return true;
    }
    banner.classList.remove('countdown--hide');
    return false;
};
const initCloseButton = (closeTrigger, banner) => {
    closeTrigger.addEventListener('click', () => {
        sessionStorage.setItem('ra-countdown-closed', '1');
        banner.classList.add('countdown--hide');
    });
};
const initCountdown = () => {
    const banner = document.querySelector(selectors.banner);
    if (banner) {
        if (!hasBeenClosed(banner)) {
            const content = banner.querySelector(selectors.content);
            const closeTrigger = banner.querySelector(selectors.closeTrigger);
            const endTime = banner.dataset.countdown;
            const countdownTime = new Date(endTime).getTime();
            const runCountdown = setInterval(() => {
                const now = new Date().getTime();
                const distance = countdownTime - now;
                const days = Math.floor(distance / (1000 * 60 * 60 * 24));
                const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((distance % (1000 * 60)) / 1000);
                const daysHtml = dataJs.countdown.days !== '' ? `${days}&nbsp;${dataJs.countdown.days}` : '';
                const hoursHtml = dataJs.countdown.hours !== '' ? ` |&nbsp;${hours}&nbsp;${dataJs.countdown.hours}` : '';
                const minutesHtml = dataJs.countdown.minutes !== '' ? ` |&nbsp;${minutes}&nbsp;${dataJs.countdown.minutes}` : '';
                const secondsHtml = dataJs.countdown.seconds !== '' ? ` |&nbsp;${seconds}&nbsp;${dataJs.countdown.seconds}` : '';
                content.innerHTML = `${daysHtml}${hoursHtml}${minutesHtml}${secondsHtml}`;
                banner.classList.add('countdown--loaded');
                if (distance < 0) {
                    clearInterval(runCountdown);
                    banner.classList.add('countdown--ended');
                }
            }, 1000);
            initCloseButton(closeTrigger, banner);
        }
    }
};
export default initCountdown;
